import React from 'react';
import PropTypes from 'prop-types';
import ChevronIcon from '../assets/chevron-icon.svg';
import prependBaseUrl from '../utils/urlHelper';
import SecondaryNavMenu from './SecondaryNavMenu';

import {
  StyledNavItem,
  NavLink,
  DesktopNavLink,
  ChevronWrapper,
  StyledText
} from './PrimaryNavItem.style';

const PrimaryNavItem = (
  {
    thisID, relNoopener, hasSubMenu, index, openedSubMenu,
    isNotDesktop, hasPopUp, thisUrl, toggleSubMenu, group,
    navHelperNew, internalLinkHelper, devMode = false,
    onTertiaryMenuChange, isTertiaryOpenGlobal = false,
    isSubMenuOpenGlobal = false, ...rest
  }
) => {
  // Determine what to render for the primary nav link
  const renderPrimaryLink = () => {
    // Mobile: Hide NavLink when secondary or tertiary menu is open
    if (isNotDesktop) {
      if (isTertiaryOpenGlobal || isSubMenuOpenGlobal) {
        return null;
      }
      return (
        <NavLink
          data-testid="NavLink"
          href={hasPopUp ? '#' : prependBaseUrl(thisUrl, devMode)}
          inline
          rel={relNoopener}
          aria-expanded={!!openedSubMenu[thisID]}
          aria-haspopup={hasPopUp}
          onClick={hasPopUp ? e => toggleSubMenu(e, thisID) : null}
          role="button"
          isExpanded={!!openedSubMenu[thisID]}
        >
          {group.primaryPageName}
          {hasSubMenu && (
            <ChevronWrapper data-testid="ChevronWrapper">
              <img src={ChevronIcon} alt="chevron icon" />
            </ChevronWrapper>
          )}
        </NavLink>
      );
    }

    // Desktop: Always show StyledText with DesktopNavLink
    return (
      <StyledText data-testid="StyledText">
        <DesktopNavLink
          data-testid="DesktopNavLink"
          href={prependBaseUrl(thisUrl, devMode)}
          inline
          rel={relNoopener}
          aria-haspopup={hasPopUp}
          hasSubMenu={hasSubMenu}
          {...rest}
        >
          {group.primaryPageName}
          {hasSubMenu && (
            <ChevronWrapper data-testid="ChevronWrapper">
              <img src={ChevronIcon} alt="chevron down icon" />
            </ChevronWrapper>
          )}
        </DesktopNavLink>
      </StyledText>
    );
  };

  return (
    <StyledNavItem
      data-testid="StyledNavItem"
      role="none"
      index={index}
      isSubMenuOpen={!!openedSubMenu}
      isTertiaryOpen={isTertiaryOpenGlobal}
      $hideContainer={isSubMenuOpenGlobal || isTertiaryOpenGlobal}
    >
      {renderPrimaryLink()}

      {hasSubMenu && (
        <SecondaryNavMenu
          data-testid="PrimaryNavMenu"
          group={group}
          isSubMenuOpen={!!openedSubMenu[thisID]}
          isTertiaryOpen={isTertiaryOpenGlobal}
          isNotDesktop={isNotDesktop}
          navHelperNew={navHelperNew}
          internalLinkHelper={internalLinkHelper}
          devMode={devMode}
          onTertiaryMenuChange={onTertiaryMenuChange}
          thisUrl={thisUrl}
          thisID={thisID}
          openedSubMenu={openedSubMenu}
        />
      )}
    </StyledNavItem>
  );
};

PrimaryNavItem.propTypes = {
  thisID: PropTypes.string.isRequired,
  index: PropTypes.number,
  hasSubMenu: PropTypes.bool,
  openedSubMenu: PropTypes.shape({}),
  toggleSubMenu: PropTypes.func.isRequired,
  hasPopUp: PropTypes.string,
  isNotDesktop: PropTypes.bool,
  thisUrl: PropTypes.string.isRequired,
  group: PropTypes.shape({
    primaryPageName: PropTypes.string.isRequired,
    primaryPageUrlIfExternal: PropTypes.string,
    primaryPageSelector: PropTypes.shape({
      path: PropTypes.string,
      title: PropTypes.string
    }),
    column1PageLinks: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string,
        pageName: PropTypes.string
      })
    ),
    column2PageLinks: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string,
        pageName: PropTypes.string
      })
    ),
    column3PageLinks: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string,
        pageName: PropTypes.string
      })
    ),
    column3PageCards: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string,
        pageName: PropTypes.string,
        pageDescription: PropTypes.string,
        primaryPageUrlIfExternal: PropTypes.string,
        image: PropTypes.shape({
          title: PropTypes.string,
          url: PropTypes.string,
          id: PropTypes.string
        })
      })
    )
  }),
  navHelperNew: PropTypes.func.isRequired,
  internalLinkHelper: PropTypes.func.isRequired,
  relNoopener: PropTypes.string,
  devMode: PropTypes.bool,
  onTertiaryMenuChange: PropTypes.func,
  isTertiaryOpenGlobal: PropTypes.bool,
  isSubMenuOpenGlobal: PropTypes.bool
};

export default PrimaryNavItem;
